(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-products"] && !Shopify.designMode) return;
  try {
    const initCartItemEditing = () => {
    const cartItemsWrapper = document.querySelector('.cart-items__wrapper');
    if (!cartItemsWrapper) return;

    const EVENT_SOURCE_ID = 'cart-items-properties';

    const toggleEditForm = (key, show) => {
      const form = cartItemsWrapper.querySelector('[data-edit-form-for="' + key + '"]');
      if (!form) return;
      if (show) {
        form.classList.remove('cart-items__edit-form--hidden');
        const input = form.querySelector('input');
        if (input) input.focus();
      } else {
        form.classList.add('cart-items__edit-form--hidden');
      }
    };

    const dispatchCartUpdateEvent = (parsedResponseText, sectionId) => {
      const sections = parsedResponseText.sections || {};
      const sectionHtml = sections[sectionId];

      const newSectionDoc = sectionHtml
        ? new DOMParser().parseFromString(sectionHtml, 'text/html')
        : null;

      const newCartHiddenItemCount = newSectionDoc?.querySelector('[ref="cartItemCount"]')?.textContent;
      const newCartItemCount = newCartHiddenItemCount ? parseInt(newCartHiddenItemCount, 10) : 0;

      const event = new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: parsedResponseText,
          sourceId: sectionId,
          data: {
            didError: false,
            source: EVENT_SOURCE_ID,
            itemCount: newCartItemCount,
            sections,
          },
        },
      });

      document.dispatchEvent(event);
    };

    const dispatchCartErrorEvent = (message, description, errors) => {
      const event = new CustomEvent('cart:error', {
        bubbles: true,
        detail: {
          sourceId: EVENT_SOURCE_ID,
          data: {
            message: message || 'Cart update failed',
            description: description || null,
            errors: errors || null,
          },
        },
      });

      document.dispatchEvent(event);
    };

    cartItemsWrapper.addEventListener('click', (event) => {
      const editButton = event.target.closest('.cart-items__edit');
      if (editButton) {
        const key = editButton.getAttribute('data-key');
        toggleEditForm(key, true);
        return;
      }

      const cancelButton = event.target.closest('.cart-items__edit-cancel');
      if (cancelButton) {
        const key = cancelButton.getAttribute('data-key');
        toggleEditForm(key, false);
        return;
      }

      const saveButton = event.target.closest('.cart-items__edit-save');
      if (saveButton) {
        const line = parseInt(saveButton.getAttribute('data-line'), 10);
        const key = saveButton.getAttribute('data-key');
        const quantity = parseInt(saveButton.getAttribute('data-quantity'), 10) || undefined;
        const form = cartItemsWrapper.querySelector('[data-edit-form-for="' + key + '"]');
        if (!form || !line) return;

        const firstNameInput = form.querySelector('input[name="recipient_first_name"]');
        const lastNameInput = form.querySelector('input[name="recipient_last_name"]');
        const emailInput = form.querySelector('input[name="recipient_email"]');

        const properties = {};
        if (firstNameInput && firstNameInput.value.trim() !== '') {
          properties['Recipient First Name'] = firstNameInput.value.trim();
        }
        if (lastNameInput && lastNameInput.value.trim() !== '') {
          properties['Recipient Last Name'] = lastNameInput.value.trim();
        }
        if (emailInput && emailInput.value.trim() !== '') {
          properties['Recipient Email'] = emailInput.value.trim();
        }

        const cartItemsComponents = document.querySelectorAll('cart-items-component');
        const sectionsToUpdate = new Set();
        cartItemsComponents.forEach((item) => {
          if (item instanceof HTMLElement && item.dataset.sectionId) {
            sectionsToUpdate.add(item.dataset.sectionId);
          }
        });

        const sectionsParam = Array.from(sectionsToUpdate).join(',');
        const sectionIdForEvent = sectionsParam.split(',')[0] || '';

        const bodyData = {
          line,
          properties,
          sections: sectionsParam,
          sections_url: window.location.pathname,
        };

        if (typeof quantity === 'number' && !Number.isNaN(quantity)) {
          bodyData.quantity = quantity;
        }

        const body = JSON.stringify(bodyData);

        const url =
          (window.Theme && window.Theme.routes && window.Theme.routes.cart_change_url) || '/cart/change.js';

        fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body,
        })
          .then((response) => response.text())
          .then((responseText) => {
            let parsed;
            try {
              parsed = JSON.parse(responseText);
            } catch (e) {
              dispatchCartErrorEvent();
              return;
            }

            if (parsed.errors) {
              dispatchCartErrorEvent(parsed.message, parsed.description, parsed.errors);
              return;
            }

            dispatchCartUpdateEvent(parsed, sectionIdForEvent);
            toggleEditForm(key, false);
          })
          .catch(() => {
            dispatchCartErrorEvent();
          });
      }
    });
  };

  const init = () => {
    initCartItemEditing();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  } catch(e) { console.error(e); }
})();

})();
